export default function initInputFile() {
  const fileInputs = document.querySelectorAll('.file-input');

  if (!fileInputs.length) return;

  fileInputs.forEach((input) => {
    input.addEventListener('change', ({ target }) => {
      const uploadField = target.closest('.upload-field');
      const fileName = target.files[0]?.name || '';

      uploadField.querySelector('.btn-upload')?.classList.toggle('file-selected', Boolean(fileName));
      const fileNameElement = uploadField.querySelector('.file-name');
      if (fileNameElement) {
        fileNameElement.classList.toggle('visible', Boolean(fileName));
        fileNameElement.textContent = fileName;
      }
    });
  });
}
